"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginStrategy = exports.accountOptions = exports.getUserData = exports.userData = exports.notExistUserResponse = exports.successfulResponse = void 0;
var interfaces_1 = require("../../interfaces");
exports.successfulResponse = {
    success: true,
    errors: null,
};
exports.notExistUserResponse = {
    success: true,
    user_existed: false,
    confirmation_token: 'abcdefgjjubj',
};
exports.userData = {
    email: 'mock_user@codebashing.com',
    is_admin: false,
    role: 'admin',
    locale: 'en',
    token: 'a',
    nickname: 'Mock',
    full_name: 'FullNameMock',
    user_id: 2,
    user_uuid: '510e06a7-5eb4-4b94-8ede-2a710c9a94d0',
    features: { custom_lesson: false, content_management: true, certificate_linkedin_share: false, labs_access: true },
    license_id: 2,
    visitor_id: 'abc',
    user_sign_in_count: 3,
    sf_account_id: '',
    account_name: 'cb',
    is_poc: false,
    is_internal: false,
    auth_type: 'login',
    customer_display_name: 'Matrix',
    is_learning_panel: true,
    is_lean_license: false,
    is_plg_tenant: false,
    is_university: false,
    custom_brand_name: 'Codedefender',
};
var getUserData = function (role) {
    if (!role)
        return exports.userData;
    if (role === interfaces_1.UserRole.admin) {
        return __assign(__assign({}, exports.userData), { is_admin: true, role: 'admin' });
    }
    if (role === interfaces_1.UserRole.manager) {
        return __assign(__assign({}, exports.userData), { role: 'manager' });
    }
    if (role === interfaces_1.UserRole.superAdmin) {
        return __assign(__assign({}, exports.userData), { role: 'superadmin' });
    }
    return exports.userData;
};
exports.getUserData = getUserData;
exports.accountOptions = {
    locales: [
        {
            name: 'en',
            display_name: 'English',
        },
        {
            name: 'fr',
            display_name: 'Français',
        },
        {
            name: 'es',
            display_name: 'Español',
        },
        {
            name: 'de',
            display_name: 'Deutsch',
        },
        {
            name: 'pt',
            display_name: 'Português',
        },
        {
            name: 'ja',
            display_name: '日本語',
        },
        {
            name: 'ko',
            display_name: '한국어',
        },
    ],
    courses: [
        {
            uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
            display_name: '.NET',
        },
        {
            uuid: '42382720-e474-4765-afdc-536d8d586389',
            display_name: '.NET - API Security',
        },
        {
            uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
            display_name: '.NET Advanced',
        },
        {
            uuid: '69668c4b-3ddb-4c33-803a-7a9f3f476cb2',
            display_name: '.NET Advanced 2',
        },
        {
            uuid: '8f305eec-0105-487e-a8ea-d2b8958fea5e',
            display_name: '.NET: Backend Security Basics',
        },
        {
            uuid: '14214b4b-15b2-444a-b077-d41b824652cd',
            display_name: 'Android',
        },
        {
            uuid: 'cc94d77d-8d1d-4c63-9a1f-36bf50f0d79d',
            display_name: 'Angular 2+',
        },
        {
            uuid: '8a180a03-5c66-459c-aae1-602163656b6d',
            display_name: 'AngularJS',
        },
        {
            uuid: '63b7fddb-cc49-4318-a248-f0ed1d49e3dd',
            display_name: 'Apple bug test',
        },
        {
            uuid: '8044df70-e20a-403c-b0d3-3e23083afebe',
            display_name: 'Application Security for Decision Makers',
        },
        {
            uuid: 'd354bd89-ed87-4b36-a81b-04da7a15ce98',
            display_name: 'Application Security for QA',
        },
        {
            uuid: 'aecca8ca-e153-40d3-8a1c-ee03b3ecb17d',
            display_name: 'Attacker Perspective: Faking GitHub Profile',
        },
        {
            uuid: 'c04d89e7-14c3-45a4-bd14-102bd432576b',
            display_name: 'C/C++',
        },
        {
            uuid: 'cb86436d-41db-4263-a3d0-3eb0b371e289',
            display_name: 'ciso 3 test',
        },
        {
            uuid: '0e2798f6-8e47-4639-9d4c-082d6ab0bea5',
            display_name: 'CISO test',
        },
        {
            uuid: '6ad1b7cb-9392-468f-9184-bc5fe00bc4c7',
            display_name: 'CISO test 2',
        },
        {
            uuid: '615cdd03-4b22-45f3-a0e5-5477c80647b0',
            display_name: 'ciso test 4',
        },
        {
            uuid: '6e004d04-1c50-46ee-8eb6-a735514724a3',
            display_name: 'ciso test 5111 lrkflefkelfk flekflefk;ef kflefklefklefkelfkelf kfjkefjekfjekfjekfj',
        },
        {
            uuid: '189f863f-6a67-45ef-9fba-47ae48eff861',
            display_name: 'Content Bar Test',
        },
        {
            uuid: '4df2555f-4592-4135-96ee-d957de5504b9',
            display_name: 'course builder course name edited',
        },
        {
            uuid: '103e1b67-3f34-4699-b5f1-80edc74efe24',
            display_name: 'Course Name For Persentation',
        },
        {
            uuid: '19a85d80-8eea-4071-b0fa-835a2b629087',
            display_name: 'Course Name Presentation',
        },
        {
            uuid: 'a1cd4210-8b3b-437e-a128-f6f072f217cf',
            display_name: 'course name test presentation 2',
        },
        {
            uuid: 'e9e5d5ad-06fe-4d3c-8f70-48379217b979',
            display_name: 'Cryptography',
        },
        {
            uuid: '2afe81a2-a0e3-44fe-8de6-9f318dd53cf0',
            display_name: 'Cryptography Basics',
        },
        {
            uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458d',
            display_name: 'CSRF',
        },
        {
            uuid: '004da7b9-29b5-4c00-8541-cfcc37e993ce',
            display_name: 'dasfsdf',
        },
        {
            uuid: 'dd9f68a1-6233-4c74-aa88-61dc438671ac',
            display_name: 'Docker',
        },
        {
            uuid: '9ed96cf4-9641-4f57-a007-546795fbaeca',
            display_name: 'Front End Security Basics',
        },
        {
            uuid: 'd848d59c-46be-4cec-9ef2-d47a05db05e0',
            display_name: 'Go',
        },
        {
            uuid: 'adb2f5cf-2d07-49b1-ac0b-de506eba684a',
            display_name: 'Hacking Headlines',
        },
        {
            uuid: 'af25c2e8-6ae8-4296-802d-e5acd5976d37',
            display_name: 'hsadkjlalsfdhjlsdf',
        },
        {
            uuid: '5adeda29-7ec0-4bee-a1fe-7937c381e8e0',
            display_name: 'HTTP Security Principles',
        },
        {
            uuid: 'b3703b99-89d5-41a3-a033-4925e9a812d7',
            display_name: 'IaC Security',
        },
        {
            uuid: '3be5f89c-341d-48ca-bae8-8c28cbb3b4d9',
            display_name: 'iOS',
        },
        {
            uuid: '23577758-4095-4478-abf3-dd956961fa50',
            display_name: 'Java',
        },
        {
            uuid: '56b0fb4b-83d6-40a2-85de-3e72a956e668',
            display_name: 'Java - API Security',
        },
        {
            uuid: '4a99a0ac-5be7-4898-8e1d-4bfbcb7333e6',
            display_name: 'Java Advanced',
        },
        {
            uuid: '9a68039b-55c6-4c9c-87e3-3f97c0f6c4ac',
            display_name: 'Java Advanced 2',
        },
        {
            uuid: 'a2913908-5694-4eb1-8718-46fa5b1ded9e',
            display_name: 'java custom',
        },
        {
            uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
            display_name: 'Java: Backend Security Basics',
        },
        {
            uuid: 'f776ef53-e87a-4186-9d3a-1ce29334530d',
            display_name: 'JWT -Json Web Token',
        },
        {
            uuid: 'e1924e85-98bd-41a6-b4f0-bff7d0ab820f',
            display_name: 'Language Agnostic Application Security',
        },
        {
            uuid: '4c73a4ac-371c-4204-951e-4c29038f4470',
            display_name: 'Miriam testing course',
        },
        {
            uuid: 'fe03cb95-7b0b-4f0a-97a3-690114b836ff',
            display_name: 'Node.JS',
        },
        {
            uuid: '96efb4bf-c662-4898-9c2d-feda66259bdd',
            display_name: 'OWASP: Java - API Security ',
        },
        {
            uuid: 'd3d89b6b-9d3d-4e76-bad7-1a802824f8b5',
            display_name: 'PHP',
        },
        {
            uuid: 'bec1d013-d686-49b4-9566-058dbb5125c9',
            display_name: 'PHP Advanced',
        },
        {
            uuid: '84b98763-0461-40e7-8bec-48257531af9e',
            display_name: 'PHP: Backend Security Basics',
        },
        {
            uuid: 'cae4bc7f-5137-4610-a1aa-5bbf2eca1a51',
            display_name: 'Python  Advanced',
        },
        {
            uuid: '3cd94db9-70e2-4754-b40c-a91bacd06c9d',
            display_name: 'Python Advanced 2',
        },
        {
            uuid: '4126fa34-31a6-4b88-8f86-1dcaa861ffa5',
            display_name: 'Python Django',
        },
        {
            uuid: '385f8f69-9e57-441b-9382-f72db93eb0b5',
            display_name: 'Python: Backend Security Basics',
        },
        {
            uuid: 'e7b4e3b8-1a56-4f5f-8a79-bf14008efd6a',
            display_name: 'React',
        },
        {
            uuid: '3a0ca2f2-7994-467e-ac00-b432be302d8b',
            display_name: 'rivka publish test 22',
        },
        {
            uuid: 'c3918f5a-f953-4356-be7d-ef79223ff0b7',
            display_name: 'Ronit test',
        },
        {
            uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
            display_name: 'Ruby on Rails',
        },
        {
            uuid: 'ba6449fe-1c8b-4f90-9345-f8c7e712a052',
            display_name: 'Scala',
        },
        {
            uuid: '11ca0e34-086b-4289-9ad0-7fd3e04fd07f',
            display_name: 'Scala: Backend Security Basics',
        },
        {
            uuid: 'e85563d9-beb0-41e5-abb5-eafd02ba237e',
            display_name: 'Source Code',
        },
        {
            uuid: 'd99f57d5-f774-4d73-ad11-aad1bd3456ff',
            display_name: 'test',
        },
        {
            uuid: 'b9c5ed62-4022-4504-ba21-8f0ba315ab9e',
            display_name: 'test-completion',
        },
        {
            uuid: '1ab8b9bc-23c9-411f-9405-60e385769025',
            display_name: 'testing 11111',
        },
        {
            uuid: '7e2c1b36-c812-4900-af98-c95251a6d7eb',
            display_name: 'testNana change name 2',
        },
    ],
    primary_course_uuid: null,
    allow_changing_primary: true,
    full_name: 'verifyme',
};
exports.loginStrategy = {
    strategy: 'login_strategy',
    is_plg_tenant: false,
    success: true,
    custom_brand_name: 'Codedefender',
};
